import { Component, OnInit, ViewChild, AfterContentChecked } from "@angular/core";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TabelaPrecoService } from "app/services/tabela-preco.service";
import { TabelaPreco } from "app/module/tabela-preco";

@Component({
	selector: 'app-tabela-preco-list',
	templateUrl: './tabela-preco-list.component.html',
	styleUrls: ['./tabela-preco-list.component.scss']
})
export class TabelaPrecoListComponent implements OnInit, AfterContentChecked {

	// Private variables
	private _unsubscribeAll: Subject<any> = new Subject();
	private tempData: TabelaPreco[] = [];

	// Public variables
	public starting: boolean = false;
	public contentHeader: any;
	public basicSelectedOption: number = 10;
	public ColumnMode = ColumnMode;
	public rows: TabelaPreco[] = [];
	public temp: TabelaPreco[] = [];
	public array_status = [
		{ status: "Ativo", id: 0 },
		{ status: "Inativo", id: 1 }
	];

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;

	constructor(private tabelaPrecoService: TabelaPrecoService) { }

	ngOnInit(): void {
		this.starting = true;
		this.tabelaPrecoService.get().pipe(
			takeUntil(this._unsubscribeAll)
		).subscribe(
			response => {
				const res = response.data;
				this.rows = res;
				this.temp = res;
				this.tempData = this.rows;
				this.starting = false;
			},
			error => {
				console.error('Erro ao carregar tabela de preços:', error);
				this.starting = false;
			}
		);

		this.contentHeader = {
			headerTitle: "Tabela de Preços",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{ name: "Início", isLink: false },
					{ name: "Tabela de Preços", isLink: false }
				]
			}
		};
	}

	ngAfterContentChecked(): void {
		this.rows = [...this.rows];
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
